import {Button} from "@/components/ui/button"
import {Workflow} from "@/model/Workflow";
import useModal, {Modal} from "@/hook/useModal";
import useUpdateWorkflow from "@/query/workflow/useUpdateWorkflow";
import toast from "react-hot-toast";
import React from "react";

export const SAVE_WORKFLOW_MODAL_ID = "save-workflow";

interface WorkflowSaveDialogProps {
    workflow: Workflow
}

const WorkflowSaveDialog: React.FC<WorkflowSaveDialogProps> = ({workflow}) => {
    const modal= useModal();

    const {mutateAsync: updateWorkflow, isLoading} = useUpdateWorkflow(workflow._id);

    const onClickSubmit = async (e: React.MouseEvent) => {
        e.stopPropagation();

        if (isLoading)
            return;

        const loadingToastId = toast.loading("logging in")

        try {
            await updateWorkflow(workflow);
            toast.success("Success", {id: loadingToastId});
            modal.close(SAVE_WORKFLOW_MODAL_ID);
        } catch (e) {
            console.log(e)
            toast.error("error", {id: loadingToastId});
        }
    }

    const onClickClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        modal.close(SAVE_WORKFLOW_MODAL_ID);
    }

    return (
        <Modal id={SAVE_WORKFLOW_MODAL_ID}
               size="sm"
               title={'Deploy Workflow'}
        >
            <div className='pt-3'>
                <span>{workflow.name}</span>
            </div>
                <div className="flex justify-end space-x-2">
                    <Button variant="outline" onClick={onClickClose}>
                        Cancel
                    </Button>
                    <Button onClick={onClickSubmit} disabled={isLoading}>
                        Deploy
                    </Button>
                </div>
        </Modal>
    )
}

export default WorkflowSaveDialog
